import Icons from './icons';
import Controls from './controls';
import Views from './views';

export default {
    Icons,
    Controls,
    Views
}